import { Types } from '../../constants/announcementTypes';

const Tabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: Types.Image, label: 'Imagen' },
    { id: Types.Pdf, label: 'PDF' },
    { id: Types.Advertisement, label: 'Anuncio' },
    { id: Types.Video, label: 'Video' },
    { id: Types.Recents, label: 'Recientes' },
  ];
  return (
    <div className="inline-flex border-b border-gray-300">
      {tabs.map(tab => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`py-2 px-4 text-sm sm:text-base font-itcmedium rounded-t-lg transition-colors duration-200
          ${activeTab === tab.id ? 'bg-blue text-white' : 'bg-transparent text-[#6B7280] hover:text-blue'}
        `}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default Tabs;